// extracted by mini-css-extract-plugin
export var description = "fc-numbers-module--description--9c71b";
export var grid = "fc-numbers-module--grid--721a6";
export var inner = "fc-numbers-module--inner--e68a4";
export var item = "fc-numbers-module--item--b92b4";
export var number = "fc-numbers-module--number--9703b";
export var root = "fc-numbers-module--root--f39f7";